import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { CreditCard, LayoutDashboard, LogOut, ShieldCheck, ShoppingBag, Store, Trophy, UserRound } from "lucide-react";
import { Logo } from "./Logo";
import { Announcement } from "./PublicLayout";
import { useAuth } from "../../context/AuthContext";

const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/store", label: "Buy Products", icon: Store },
  { to: "/predictions", label: "Predictions", icon: Trophy },
  { to: "/purchases", label: "My Purchases", icon: ShoppingBag },
  { to: "/payments", label: "Payments", icon: CreditCard },
  { to: "/account", label: "Account", icon: UserRound },
];

const cls = ({ isActive }) =>
  `flex items-center gap-2 whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium transition-colors ${isActive ? "bg-white/[0.07] text-white" : "text-slate-400 hover:text-white"}`;

export default function AppShell() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const out = async () => { await logout(); nav("/"); };
  return (
    <div className="min-h-screen">
      <Announcement />
      <header className="sticky top-0 z-40 border-b border-white/[0.06] bg-[#0b0f17]/85 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 lg:px-8">
          <Logo to="/dashboard" />
          <nav className="hidden items-center gap-1 xl:flex">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} className={cls} data-testid={`app-nav-${n.to.slice(1)}`}>
                <n.icon size={16} /> {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-2">
            {user?.role === "admin" && (
              <Link to="/admin" className="btn-ghost px-3 py-2" data-testid="app-nav-admin"><ShieldCheck size={16} /> Admin</Link>
            )}
            <span className="hidden text-sm text-slate-400 md:block" data-testid="app-user-name">{user?.full_name}</span>
            <button onClick={out} className="btn-ghost px-3 py-2" data-testid="logout-btn" aria-label="Log out"><LogOut size={16} /></button>
          </div>
        </div>
        <nav className="no-scrollbar flex gap-1 overflow-x-auto border-t border-white/[0.04] px-4 py-2 xl:hidden">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={cls} data-testid={`app-mnav-${n.to.slice(1)}`}>
              <n.icon size={15} /> {n.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="mx-auto max-w-7xl px-5 py-10 lg:px-8 lg:py-14">
        <Outlet />
      </main>
    </div>
  );
}
